import "./Teams.css";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { PulseLoader } from "react-spinners";
import PrimaryButton from "../../../Components/Atoms/Buttons/Primary/PrimaryButton";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import config from "../../../config";
import {
  Card,
  CardContent,
  Grid,
  Typography,
  Box,
  Chip,
  IconButton,
  Tooltip,
  Button,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
  useMediaQuery,
  tableCellClasses,
} from "@mui/material";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  "&:first-child": {
    borderRadius: "5px 0 0 0",
  },
  "&:last-child": {
    borderRadius: "0 5px 0 0",
  },
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: config.PRIMARY_COLOR,
    color: theme.palette.common.white,
    fontSize: "15px",
  },
}));

const columns = [
  { id: "code", label: "Team Code", minWidth: 120 },
  { id: "name", label: "Team Name", minWidth: 120 },
  {
    id: "category",
    label: "Category",
    minWidth: 120,
  },
  { id: "ageGroup", label: "Age Group", minWidth: 120 },
  {
    id: "coach",
    label: "Coach",
    minWidth: 120,
  },
  // { id: "isPaid", label: "Paid", maxWidth: 50, align: "center" },
  {
    id: "operations",
    label: "",
    minWidth: 80,
    maxWidth: 80,
    align: "right",
  },
];

function Teams({
  page,
  searchData,
  search,
  setSearchData,
  setSearch,
  navigate,
  handleChangePage,
  loading,
  pageCount,
  teams,
  setTeamDeleted,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <div className="mainContainer">
      <div className="cont">
        <Box
          className="header"
          sx={{
            display: "flex",
            justifyContent: { xs: "space-between", md: "flex-end" },
            gap: 2,
          }}
        >
          {/* <div
            style={{
              display: "flex",
              alignItems: "center",
              marginRight: "10px",
              justifyContent: "space-between",
            }}
          > */}
          {/* <TextFieldInput
              searchIcon={true}
              Required={false}
              type="text"
              placeholder={"Search"}
              className="SearchBar"
              name={"search"}
              change={(e) => setSearchData(e.target.value)}
              newValue={searchData}
              searchAction={() => {
                if (search != searchData) {
                  setSearch(searchData);
                }
              }}
              keyDown={(e) => {
                if (e.keyCode === 13)
                  if (search != searchData) {
                    setSearch(searchData);
                  }
              }}
            /> */}
          {/* <Filter country city activated setFilter={setFilter} /> */}
          {/* </div> */}
          <PrimaryButton
            classBtn={"center addButton"}
            text={"Add New Team"}
            style={{
              textTransform: "capitalize",
              borderRadius: "5px",
              color: config.SECONDARY_COLOR,
              backgroundColor: config.PRIMARY_COLOR,
              height: "40px",
              padding: "0 30px",
              minWidth: "100px",
              textWrap: "noWrap",
            }}
            click={() => {
              navigate("/teams/add");
            }}
          />
          <PrimaryButton
            classBtn={"center addButton"}
            text={"Go To Payment"}
            style={{
              textTransform: "capitalize",
              borderRadius: "5px",
              color: config.SECONDARY_COLOR,
              backgroundColor: config.PRIMARY_COLOR,
              height: "40px",
              padding: "0 30px",
              minWidth: "100px",
              textWrap: "noWrap",
            }}
            click={() => {
              navigate("/transactions");
            }}
          />
        </Box>
        {!loading ? (
          <>
            {!teams?.length ? (
              <h3 style={{ textAlign: "center", margin: "50px" }}>
                No Teams Added Yet!!
              </h3>
            ) : isMobile ? (
              <Paper
                className="tableCont"
                sx={{ width: "100%", padding: "20px", borderRadius: "10px" }}
              >
                <Grid container spacing={3}>
                  {teams?.map((team, index) => (
                    <Grid item xs={12} sm={6} key={team?.id}>
                      <Card
                        sx={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          transition: "transform 0.2s, box-shadow 0.2s",
                          "&:hover": {
                            transform: "translateY(-4px)",
                            boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            backgroundColor: config.PRIMARY_COLOR,
                            color: "white",
                            padding: "7px 12px",
                            borderRadius: "12px",
                            fontSize: "0.875rem",
                            fontWeight: "bold",
                            textAlign: "center",
                          }}
                        >
                          Team {index + 1}
                        </Box>
                        <CardContent sx={{ pt: 2 }}>
                          <Typography
                            variant="h5"
                            component="div"
                            gutterBottom
                            sx={{
                              fontWeight: "bold",
                              color: config.PRIMARY_COLOR,
                              mb: 2,
                            }}
                          >
                            {team.name}
                          </Typography>

                          <Divider sx={{ my: 2 }} />

                          <Box sx={{ mb: 1 }}>
                            <Typography
                              variant="subtitle2"
                              color="text.secondary"
                              sx={{ mb: 1 }}
                            >
                              Category & Age Group
                            </Typography>
                            <Box
                              sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}
                            >
                              <Chip
                                label={team.category?.name}
                                size="small"
                                sx={{
                                  backgroundColor: "#e3f2fd",
                                  color: "#1976d2",
                                }}
                              />
                              <Chip
                                label={team.ageGroup?.name}
                                size="small"
                                sx={{
                                  backgroundColor: "#e8f5e9",
                                  color: "#2e7d32",
                                }}
                              />
                            </Box>
                          </Box>

                          <Box sx={{ mb: 1 }}>
                            <Typography
                              variant="subtitle2"
                              color="text.secondary"
                              sx={{ mb: 1 }}
                            >
                              Coach:
                              <span
                                style={{
                                  fontWeight: "bold",
                                  color: "black",
                                  marginLeft: "10px",
                                }}
                              >
                                {team.coach?.name || "-"}
                              </span>
                            </Typography>
                          </Box>

                          {/* {config.APP_NAME === "Code Reg" && (
                            <Box sx={{ mb: 1 }}>
                              <Typography
                                variant="subtitle2"
                                color="text.secondary"
                                sx={{ mb: 1 }}
                              >
                                Participation
                              </Typography>
                              <Box sx={{ display: "flex", gap: 1 }}>
                                <Chip
                                  icon={
                                    team.onlineParticipant ? (
                                      <DoneIcon />
                                    ) : (
                                      <CloseIcon />
                                    )
                                  }
                                  label="Online"
                                  size="small"
                                  color={
                                    team.onlineParticipant
                                      ? "success"
                                      : "default"
                                  }
                                  sx={{ minWidth: "90px" }}
                                />
                                <Chip
                                  icon={
                                    team.offlineParticipant ? (
                                      <DoneIcon />
                                    ) : (
                                      <CloseIcon />
                                    )
                                  }
                                  label="Offline"
                                  size="small"
                                  color={
                                    team.offlineParticipant
                                      ? "success"
                                      : "default"
                                  }
                                  sx={{ minWidth: "90px" }}
                                />
                              </Box>
                            </Box>
                          )} */}

                          <Box
                            sx={{
                              mt: 2,
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={(e) => {
                                e.stopPropagation();
                                navigate(`/teams/${team?.id}`);
                              }}
                              sx={{
                                backgroundColor: config.PRIMARY_COLOR,
                                "&:hover": {
                                  backgroundColor: config.PRIMARY_COLOR,
                                  opacity: 0.9,
                                },
                              }}
                            >
                              See More Details
                            </Button>
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </Paper>
            ) : (
              <Paper
                className="tableCont"
                sx={{ width: "fit-content", minWidth: "100%" }}
              >
                <TableContainer>
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        {columns.map((column) => (
                          <StyledTableCell
                            key={column.id}
                            align={column.align}
                            style={{
                              minWidth: column.minWidth,
                            }}
                          >
                            {column.label}
                          </StyledTableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {teams?.map((team) => (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={team?.id}
                          onClick={() => {
                            navigate(`/teams/${team.id}`);
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          {columns.map((column) => {
                            const value = team[column.id];
                            return (
                              <TableCell
                                key={column.id}
                                align={column.align}
                                style={{ padding: "10px" }}
                              >
                                {column.id === "code" ? (
                                  value ?? "-"
                                ) : column.id === "isPaid" ||
                                  column.id === "onlineParticipant" ||
                                  column.id === "offlineParticipant" ? (
                                  value ? (
                                    <DoneIcon className="activatedTick" />
                                  ) : (
                                    <CloseIcon className="NonActivatedTick" />
                                  )
                                ) : column.id === "ageGroup" ||
                                  column.id === "coach" ||
                                  column.id === "category" ? (
                                  value?.name
                                ) : column.id === "operations" ? (
                                  <VisibilityIcon
                                    sx={{
                                      color: "green",
                                      cursor: "pointer",
                                      margin: "0 0 0 5px",
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      navigate(`/teams/${team?.id}`);
                                    }}
                                  />
                                ) : (
                                  value
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            )}
          </>
        ) : (
          <div className="loadingBox">
            <PulseLoader color={config.PRIMARY_COLOR} />
          </div>
        )}
      </div>
    </div>
  );
}

export default Teams;
